import {
  createPrivateEvent,
  PrivateEventForbiddenError,
  PrivateEventValidationError,
} from '../../api/privateEvents';

import type { PrivateEventFormFields } from './private-event-form-state';
import { buildCreateInput, firstErrorStep } from './private-event-payload';

const WHEN_WHERE_STEP = 0;
const GENERIC_FAILURE = 'Could not create the private event.';

export interface SubmitArgs {
  fields: PrivateEventFormFields;
  onCreated: (id: string) => void;
  setSubmitting: (b: boolean) => void;
  setFormError: (s: string | null) => void;
  setFieldErrors: (m: Record<string, string>) => void;
  setStep: (i: number) => void;
}

/** POST the create and send each kind of refusal to where it can be read: a
 *  field error to its step, a permission refusal to the region it is about. */
export async function submitPrivateEvent(args: SubmitArgs): Promise<void> {
  const { fields, onCreated, setSubmitting, setFormError, setFieldErrors, setStep } = args;
  setSubmitting(true);
  setFormError(null);
  setFieldErrors({});
  try {
    const { id } = await createPrivateEvent(buildCreateInput(fields));
    onCreated(id);
  } catch (err) {
    if (err instanceof PrivateEventValidationError) {
      setFieldErrors(err.fieldErrors);
      setFormError(err.message);
      setStep(firstErrorStep(err.fieldErrors));
    } else if (err instanceof PrivateEventForbiddenError) {
      setFormError(err.message);
      setStep(WHEN_WHERE_STEP);
    } else {
      setFormError(err instanceof Error ? err.message : GENERIC_FAILURE);
    }
  } finally {
    setSubmitting(false);
  }
}
